module.exports = __webpack_public_path__ + "img/empCertificateFile.4e174a62.jpg";